const apiAccess = {
  apiAccess: {
    apiAccessTitle: 'Accesso API',
    apiAppContent:
      "Con l'API Enlighten Systems, gli sviluppatori di software possono scrivere applicazioni esterne in grado di leggere i dati di produzione del sistema. Queste applicazioni possono chiedere agli utenti di inserire un ID utente per effettuare richieste API da parte loro. Il tuo ID utente è %{user_id}.",
    showApp: 'Mostra applicazioni che dispongono di accesso API',
    isGrantedApp: "Non hai concesso l'accesso API a nessuna applicazione.",
    apiSystemContent:
      "Un'applicazione esterna può solo recuperare i dati per i sistemi che consentono l'accesso API. Ciò è controllato dal proprietario del sistema. Se un sistema che puoi vedere non è visualizzato qui, è perché il proprietario ha scelto di non consentire l'accesso API.",
    showSystem: "Mostra sistemi che consentono l'accesso API",
    isGrantedSystem: "Non hai concesso l'accesso API a nessun sistema.",
    revokeAccess: 'Revoca accesso'
  }
};

export default apiAccess;
